import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/tag.ts
const imageToPromptResultSchema = z.object({ output: z.array(z.string()) });
const tagContract = oc.prefix("/tag").tag("Tag").router({ suggestPromptForImage: oc.route({
	method: "GET",
	path: "/suggest-prompt/{mediaId}"
}).input(z.object({ mediaId: z.string() })).output(imageToPromptResultSchema).errors({ MEDIA_NOT_FOUND: {
	status: 404,
	message: "Media not found"
} }) });
//#endregion
export { imageToPromptResultSchema, tagContract };
